import type { ThemeConfig } from 'antd';

/** §1: «стиль Excel/1С, плотные таблицы, без скруглений и лишних отступов, шрифт 12px везде». */
export const ownerTheme: ThemeConfig = {
  token: {
    // Плавающие окна (`FloatingWindow`) держат свой z-index на базе 1000+N (счётчик фокуса),
    // растущий по мере переключения между окнами в сессии — поднять базу попапов antd
    // (Select/DatePicker/Dropdown) с запасом выше, иначе их выпадающий список рисуется под
    // белым фоном окна и выглядит "пустым", хотя данные в нём есть.
    zIndexPopupBase: 2000,
    fontSize: 12,
    fontSizeSM: 12,
    fontSizeLG: 12,
    fontSizeXL: 12,
    fontSizeHeading1: 20,
    fontSizeHeading2: 18,
    fontSizeHeading3: 16,
    fontSizeHeading4: 14,
    fontSizeHeading5: 12,
    borderRadius: 0,
    borderRadiusSM: 0,
    borderRadiusLG: 0,
    borderRadiusXS: 0,
    controlHeight: 24,
    controlHeightSM: 22,
    controlHeightLG: 28,
    lineHeight: 1.35,
    padding: 8,
    paddingSM: 6,
    paddingXS: 4,
    margin: 8,
    marginXS: 4,
  },
  components: {
    Table: { cellPaddingBlockSM: 2, cellPaddingInlineSM: 6, headerBg: '#f0f0f0', rowHoverBg: '#eef4fb', fontSize: 12 },
    Form: { itemMarginBottom: 6 },
    Modal: { titleFontSize: 12 },
    Card: { paddingLG: 8 },
  },
};

/** §9: кабинет клиента — отдельная тема под телефон (14px, контролы 36px, без скруглений). */
export const clientTheme: ThemeConfig = {
  token: {
    fontSize: 14,
    fontSizeSM: 13,
    fontSizeLG: 16,
    fontSizeXL: 18,
    fontSizeHeading1: 22,
    fontSizeHeading2: 20,
    fontSizeHeading3: 18,
    fontSizeHeading4: 16,
    fontSizeHeading5: 14,
    borderRadius: 0,
    borderRadiusSM: 0,
    borderRadiusLG: 0,
    borderRadiusXS: 0,
    controlHeight: 36,
    controlHeightSM: 32,
    controlHeightLG: 40,
    lineHeight: 1.5,
    padding: 12,
    paddingSM: 8,
    paddingXS: 6,
    margin: 12,
    marginXS: 8,
  },
  components: {
    Table: { fontSize: 14 },
    Card: { paddingLG: 12 },
  },
};
